import companies from "../../redux/reducers/company";
import ModelService from "../../redux/services/ModelService";
import { getPRPC } from "../../hooks/usePRPC";
import createRPCQuery from "../../utils/createRPCQuery.util";
import { createObjectLanguageNamesFromObject } from "../../assets/languages/langs";
import { Language } from "..";

class Company extends ModelService<
	Company.SubscribeOptions,
	Company.Model,
	"companies"
>(companies, (state) => state.company) {
	static fromResponse(data: any): Company.Model {
		return {
			id: data.id,
			name: createObjectLanguageNamesFromObject(data.name),
			login: data.login,

			createdAt: data.createdAt,
			updatedAt: data.updatedAt,
			deletedAt: data.deletedAt,
		};
	}

	static Global = {
		async index() {
			const prpc = getPRPC();

			if (!prpc) return null;
			if (!prpc.theirsModel?.company?.getAll) return null;

			const result = await createRPCQuery(() =>
				prpc.theirsModel.company.getAll(),
			);

			const cache = (result.items as any[])
				.map(Company.fromResponse)
				.sort((company1, company2) => company1.id - company2.id);

			return {
				cache,
				offset: 0,
				limit: cache.length,
				total: cache.length,
				deprecated: false,
			};
		},
	};

	static async getById(id: number) {
		const prpc = getPRPC();
		if (!prpc?.theirsModel?.company?.getById) return null;

		return createRPCQuery(() => prpc.theirsModel.company.getById(id));
	}

	static async update(
		id: number,
		params: {
			settings: {
				notification?: {
					firebase?: {
						client?: FirebaseBlockValue;
						executor?: FirebaseBlockValue;
					};
				};
				reports?: {
					anta?: Company.AntaRequisites;
				};
			};
		},
	) {
		const prpc = getPRPC();
		if (!prpc?.theirsModel?.company?.update) return null;

		return createRPCQuery(() =>
			prpc.theirsModel.company.update(id, params),
		);
	}
}

export interface FirebaseBlockValue {
	baseURL?: string;
	serverKey?: string;
	senderId?: string;
	credentials?: string;
	iosApplication?: string;
	iosSandbox?: boolean;
}

declare namespace Company {
	interface Model {
		id: number;

		name: Record<Language, string>;
		login: string;

		createdAt: Date;
		updatedAt: Date;
		deletedAt: Date;
	}

	interface SubscribeOptions {}

	/** Реквизиты платформы для отчёта ANTA (company.settings.reports.anta). */
	interface AntaRequisites {
		platformBrand: string;
		legalEntityName: string;
		legalEntityIdno: string;
	}
}

export default Company;
